import React, { useMemo, Fragment } from 'react';
import '../Gallery.module.css';
import { dataImages, dimensionsH, dimensionsV } from './data19a.js';
import useWindowWidth from '../../../helpers/helper'

export const Gallery19a = () => {
  const isDesktop = useWindowWidth(600);

  const images = useMemo(() => {
    return dataImages.map((image) => {
      let randomDimensionH = dimensionsH[Math.floor(Math.random() * dimensionsH.length)];
      let randomDimensionV = dimensionsV[Math.floor(Math.random() * dimensionsV.length)];
      return (
        // eslint-disable-next-line react/jsx-key
        <Fragment>
          {
            isDesktop ? (
              <div className='galleryImgDesktopContainer'>
                <img
                  style={{
                    width: image.orientation == "h" ? Number(randomDimensionH.width) : Number(randomDimensionV.width),
                    height: 'auto',
                    marginRight: 20,
                    marginBottom: 120,
                  }}
                  className='galleryImgDesktop'
                  src={image.pictureSrc}
                  resizeMode="contain"
                  key={image.id}
                />
                <div>
                  <p>{image.description}</p>
                  <p>{image.dimensions}</p>
                </div>
                </div>) : (
              <div className='galleryImgMobileContainer'>
                  <img
                    style={{
                      maxWidth: "100%",
                    }}
                    className="homeImg"
                    src={image.pictureSrc}
                    resizeMode="contain"
                    key={image.id}
                  />
                <div>
                  <p>{image.description}</p>
                  <p>{image.dimensions}</p>
                </div>
              </div>
            )
          }
        </Fragment>
      )
    }
    )
  }, []);

  return (
    <Fragment>
      {images}
    </Fragment>
  );
};


// WEBPACK FOOTER //
// ./src/pages/gallery/19a/gallery19a.jsx